import { acceptStringValue } from '../../field-viewer/shared-normalizers';
export const contactsFirstNameViewer = {
    normalizeLoadedValue: acceptStringValue
};

//# sourceMappingURL=definition-viewer.js.map